export const ENV = process.env.REACT_APP_ENV || process.env.NODE_ENV;
export { default as permissions } from './permissions';
